<template>
    <div class="columns m-b-5-mobile">
        <div class="column is-12" :class="{'d-none': !listdata.length }" >
            <div class="category-search" v-if="listdata.length > 1">
            <!-- <p v-if="selected !== ''" class="mb-2 label-selected">{{name}} <button v-if="tt!=''" v-tooltip="tt">?</button>
            </p>
            <b-select
                :class="selected !== '' ? 'dropdown-selected' : 'default-value'"
                placeholder="--select--"
                @input="submit()"
                v-model="selected"
                :expanded="true"
                :disabled="listdata.length==1">
                <option value="" v-if="listdata.length > 1"> <span>{{name}}</span> - All</option>
                <option :value="i" v-for="i in listdata">
                    {{ i }}
                </option>
            </b-select> -->
            <p v-if="selected !== name" class="mb-2 label-selected">{{name}} <button v-if="tt!=''" v-tooltip="tt">?</button>
            </p>
            <v-select
                :class="selected !== name ? 'dropdown-selected' : 'default-value'"
                placeholder="--select--"
                @input="submit()"
                v-model="selected"
                :disabled="listdata.length==2"
                :options="listdata"
                :clearable="false"
                :searchable="false"
            >
                <template #option="{label}">
                    <span v-if="label === name">{{label}} <span class="text-grey">- All</span></span>
                    <span v-else>{{label}}</span>
                </template>
                <template #selected-option="{label}">
                    <span v-if="label === name">{{label}} <span class="text-grey">- All</span></span>
                    <span v-else>{{label}}</span>
                </template>
            </v-select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CategorySearch',
    props:{
        name:String,
        code:String,
        clear:Boolean,
        tt:String,
    },
    data(){
        return{
            selected:this.name,
            listdata:[],
            snapshot:false,
            originalValue: {},
        }
    },
    methods:{
        submit(){
            this.snapshot = true
            this.$emit('category-selection', {[this.code]: this.selected === this.name ? '' : this.selected})
        }
    },

    watch:{
        clear(){
            this.selected = this.name
            this.snapshot = false
        },
        '$store.state.search.homeCategoryList':{
            handler(n) {
                if(this.snapshot === true){
                    let originalValue = {};
                    originalValue[this.code] = Object.assign({}, this.originalValue );
                    this.$store.commit("search/SET_LASTEST_SELECTED_CATEGORY", originalValue)
                    this.snapshot = false
                }
                else if(n.hasOwnProperty(this.code)){
                    this.originalValue = Object.assign({}, n[this.code]);
                    this.listdata = Object.values(n[this.code])
                    this.listdata.unshift(this.name)
                }
                else{
                    this.listdata = []
                }
                if(!this.listdata.includes(this.selected)){
                    this.selected = this.name
                }
                if(this.listdata.length == 1){
                    this.selected = this.listdata[0]
                }
                if(this.listdata.length == 2){
                    this.selected = this.listdata[1]
                }
            },
            deep:true,
            immediate: true // provides initial (not changed yet) state
        },
        selected(n){
            this.$emit('category-vals', {[this.code]: n === this.name ? '' : n })
        },
    },
}

</script>

<style>
.w100{
    width: 100%;
}
</style>
